import { render, staticRenderFns } from "./hqnotice-close.vue?vue&type=template&id=0e454fdd&scoped=true&"
import script from "./hqnotice-close.vue?vue&type=script&lang=js&"
export * from "./hqnotice-close.vue?vue&type=script&lang=js&"
import style0 from "./hqnotice-close.vue?vue&type=style&index=0&id=0e454fdd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e454fdd",
  null
  
)

export default component.exports